/* iTOVi — PDP gallery thumbnail swap */
(function(){
  const main = document.querySelector('.gallery-main img');
  const thumbs = [...document.querySelectorAll('.gallery-thumbs button')];
  if (!main || !thumbs.length) return;
  thumbs.forEach(btn => btn.addEventListener('click', () => {
    const src = btn.dataset.full || btn.querySelector('img').src;
    main.style.opacity = '0';
    setTimeout(() => { main.src = src; main.style.opacity = '1'; }, 120);
    thumbs.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }));
})();
